import React from 'react';
import { Link } from 'react-router-dom';

const DataPlatformPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Data Platform</h1>
      <p className="text-xl mb-8">
        Unlock the full potential of your data with our comprehensive data platform.
        From collection to analysis, we provide the tools you need to make data-driven decisions.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4">Platform Capabilities</h2>
          <ul className="space-y-3">
            <li>• Real-time data processing</li>
            <li>• Advanced analytics tools</li>
            <li>• Secure data storage</li>
            <li>• Data visualization</li>
            <li>• Machine learning integration</li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4">Data Insights</h2>
          <ul className="space-y-3">
            <li>• Predictive analytics</li>
            <li>• Business intelligence</li>
            <li>• Custom reporting</li>
            <li>• Trend analysis</li>
            <li>• Performance metrics</li>
          </ul>
        </div>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg text-center">
        <h2 className="text-2xl font-semibold mb-4">Harness Your Data's Power</h2>
        <p className="mb-6">
          Learn how our Data Platform can help you make better decisions and drive business growth.
        </p>
        <Link
          to="/contact"
          className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Explore Solutions
        </Link>
      </div>
    </div>
  );
};

export default DataPlatformPage; 